import {appFetch, AppFetchResponse} from "../utils/appFetch";
import {ConsentIntegrationOptions} from "../components/consentIntegrationSection/ConsentIntegrationSection";

export const updateOtpService = async (domain: string, friendlyName: string, language: string): Promise<AppFetchResponse> => {
    return appFetch({
        endpoint: `communication-provider/otp-service`,
        method: 'POST',
        headers: {
            "Content-Type": "application/json",
        },
        domain,
        params: { friendlyName, language },
        isEncrypted: true,
    });
}